<form class="au-forms date-interval-form" (click)="$event.stopPropagation()">
	<span class="offset-span" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
		<mat-icon
			[ngClass]="hasSelectedGranularity() ? 'active' : 'disabled'"
			svgIcon="nav_arrow_backward"
			(click)="decrement()"
		/>
		<span
			class="title-container"
			(click)="granularityMenuOpen.set(!granularityMenuOpen())"
		>
			<h3 class="title">
				{{ label() }}
			</h3>
		</span>
		<mat-icon
			[ngClass]="hasSelectedGranularity() ? 'active' : 'disabled'"
			svgIcon="nav_arrow_forward"
			(click)="increment()"
		/>
	</span>
</form>

<ng-template
	cdkConnectedOverlay
	[cdkConnectedOverlayOrigin]="trigger"
	[cdkConnectedOverlayOpen]="granularityMenuOpen()"
	[cdkConnectedOverlayPositions]="[
		{ originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' },
	]"
	(overlayOutsideClick)="granularityMenuOpen.set(false)"
>
	<mat-list class="granularity-menu">
		@for (optionValue of options; track optionValue) {
			<mat-list-item
				(click)="granularityMenuOpen.set(false); setGranularity(optionValue)"
				>{{ optionValue.toLowerCase() | translate }}</mat-list-item
			>
		}
	</mat-list>
</ng-template>
